import React from 'react'
import './index.css'
import FlexColumn from 'components/FlexColumn'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import H2 from 'components/H2'
import P from 'components/P'
import useIsMediumScreen from 'hooks/use-is-medium-screen'
import ButtonLink from 'components/ButtonLink'
import { ROUTE_PATH } from 'modules/route/constants'
import CloseButton from 'components/CloseButton'
import logUtil from 'utils/log'
import Flex from 'components/Flex'
import classNames from 'classnames'
import setShouldScrollToReferAFriendAfterSignInUtil from 'pages/Squad/utils/set-scroll-to-refer-a-friend-after-sign-in'
import handleResizePositionFixedComponentUtil from 'utils/component/handle-resize-position-fixed'
import { LOYALTY_REFER_A_FRIEND_PERCENTAGE_OFF_LABEL } from 'modules/loyalty/constants'

const TITLE = `Get ${LOYALTY_REFER_A_FRIEND_PERCENTAGE_OFF_LABEL} when you invite a new friend`
const DESCRIPTION = `They get ${LOYALTY_REFER_A_FRIEND_PERCENTAGE_OFF_LABEL} their first order.`
const CTA = 'Share with a friend'
const ANALYTICS_EVENT = {
  SQUAD_SHARE_WITH_A_FRIEND: 'SQUAD_SHARE_WITH_A_FRIEND',
  SQUAD_CLOSE_SHARE_WITH_A_FRIEND: 'SQUAD_CLOSE_SHARE_WITH_A_FRIEND'
}
export default function SquadPageGetBonusPointsWhenYouInviteANewFriendPopover () {
  const isMediumScreen = useIsMediumScreen()
  const ref = React.useRef()
  const linkRef = React.useRef()
  const parentRef = React.useRef()
  const closeButtonRef = React.useRef()
  const [isVisible, setIsVisible] = React.useState(true)

  const debugProps = {
    isMediumScreen,
    isVisible
  }
  logUtil('SquadPageGetBonusPointsWhenYouInviteANewFriendPopover').debug('debugProps=', debugProps)

  const handleShareWithAFriend = () => {
    logUtil('SquadPageGetBonusPointsWhenYouInviteANewFriendPopover#handleShareWithAFriend').debug('[start]')
    setShouldScrollToReferAFriendAfterSignInUtil()
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_SHARE_WITH_A_FRIEND)
  }

  const handleClickClose = () => {
    logUtil('SquadPageGetBonusPointsWhenYouInviteANewFriendPopover#handleClickClose').debug('[start]')
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_CLOSE_SHARE_WITH_A_FRIEND)
    setIsVisible(false)
  }

  React.useEffect(() => {
    if (!parentRef.current && ref.current) {
      parentRef.current = ref.current.parentNode
    }

    // TODO `onClick` does not seem to trigger when position is fixed (desktop)
    closeButtonRef.current?.addEventListener?.('click', handleClickClose)
    linkRef.current?.addEventListener?.('click', handleShareWithAFriend)

    if (isVisible) {
      handleResizePositionFixedComponentUtil({
        ref,
        isInsideParent: isMediumScreen,
        parentRef
      })
    }
    return () => {
      closeButtonRef.current?.removeEventListener?.('click', handleClickClose)
      linkRef.current?.removeEventListener?.('click', handleShareWithAFriend)
    }
  }, [isMediumScreen, isVisible])

  return (
    <FlexColumn
      className={
        classNames({
          'squad-get-bonus-points-when-you-invite-a-new-friend': true,
          'squad-get-bonus-points-when-you-invite-a-new-friend_visible': isVisible
        })
      }
      ref={ref}
    >
      <Flex
        className='squad-get-bonus-points-when-you-invite-a-new-friend-button'
      >
        <CloseButton ref={closeButtonRef} />
      </Flex>
      <H2>{TITLE}</H2>
      <P>{DESCRIPTION}</P>
      <ButtonLink
        href={ROUTE_PATH.ACCOUNT_LOYALTY}
        ref={linkRef}
      >
        {CTA}
      </ButtonLink>
    </FlexColumn>
  )
}
